module.exports = __webpack_public_path__ + "img/IWG_M20_Mini.144bc371.png";